const vntBottomReviews = document.getElementById("bottom-review");
vntBottomReviews.style.display = "none";

// const vntGiftCardImage = document.getElementById("vntGiftCardImage");
// vntGiftCardImage.src = "//www.vertagear.com/cdn/shop/t/103/assets/gift-card-mobile.jpg?v=40275818353049138701787214174";
// const vntScreenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
// if (vntScreenWidth >= 768) {
//   vntGiftCardImage.src = "//www.vertagear.com/cdn/shop/t/103/assets/gift-card-desktop.jpg?v=116879505969531611481787214174";
// }

// const vntScreenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
// if (vntScreenWidth >= 768) {
//   const vntGiftCardVideo = document.getElementById("vntGiftCardVideo");
//   vntGiftCardVideo.src = "//www.vertagear.com/cdn/shop/t/103/assets/gift-card-desktop.mp4?v=172783140504306450961787214217";
// }

const vntGiftCardHow = document.getElementById("vntGiftCardHow");
const vntNewEditTop = document.getElementById("new-edit-top");
vntNewEditTop.appendChild(vntGiftCardHow);

const vntGiftCardIcon1 = document.getElementById("vnt-giftcard-icon1");
const vntGiftCardIcon2 = document.getElementById("vnt-giftcard-icon2");
const vntGiftCardIcon3 = document.getElementById("vnt-giftcard-icon3");
const vntGiftCardIcon4 = document.getElementById("vnt-giftcard-icon4");
const vntGiftCardIcon5 = document.getElementById("vnt-giftcard-icon5");
vntGiftCardIcon1.src = "//www.vertagear.com/cdn/shop/t/103/assets/giftcard-icon1-purple.svg?v=134305612296868750231787214172";
vntGiftCardIcon2.src = "//www.vertagear.com/cdn/shop/t/103/assets/giftcard-icon2-purple.svg?v=177724003133031020461787214172";
vntGiftCardIcon3.src = "//www.vertagear.com/cdn/shop/t/103/assets/giftcard-icon3-purple.svg?v=140508453313473215251787214172";
vntGiftCardIcon4.src = "//www.vertagear.com/cdn/shop/t/103/assets/giftcard-icon4-purple.svg?v=68586188555815229421787214172";
vntGiftCardIcon5.src = "//www.vertagear.com/cdn/shop/t/103/assets/giftcard-icon5-purple.svg?v=7791711375964601821787214172";